import { isValid, parse, parseISO } from 'date-fns'

/** Stay dates in URLs are local calendar days, not `new Date('yyyy-MM-dd')` (UTC midnight). */
const STAY_DATE_FORMAT = 'yyyy-MM-dd'

export function parseIsoDateOnlyToLocalDate(value: string): Date | null {
	const d = parse(value.trim(), STAY_DATE_FORMAT, new Date(0))
	return isValid(d) ? d : null
}

/**
 * Prefer strict `yyyy-MM-dd` (calendar day). Otherwise `parseISO` (date-fns), then `Date`.
 * Use for URL/query values that may occasionally include time or offset.
 */
export function parseStayDateFromUrlOrLegacy(value: string): Date {
	const strict = parseIsoDateOnlyToLocalDate(value)
	if (strict) return strict

	const trimmed = value.trim()
	const iso = parseISO(trimmed)
	if (isValid(iso)) return iso

	return new Date(value)
}

/** App constants always emit `yyyy-MM-dd`; failure means a programming error. */
export function requireStayDateFromIso(iso: string, context: string): Date {
	const d = parseIsoDateOnlyToLocalDate(iso)
	if (!d) {
		throw new Error(`${context}: invalid stay date ISO "${iso}"`)
	}
	return d
}